import React, { useState, useEffect, useContext } from "react";
import { 
    Grid,
    IconButton,
    Tooltip,
    Button,
    CircularProgress,
    Typography,
    Dialog,
    DialogActions,
    DialogTitle
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import {
    AddCircle,
    
} from '@material-ui/icons';
import axios from "axios";
import { AppContext } from '../../context/AppContext';
  
const Invitations = () => {
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [data, setData] = useState(undefined);
    const [selectedOrg, setSelectedOrg] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const appCtx = useContext(AppContext);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [briefId, setBriefId] = useState()
    const [showCopyMessage, setShowCopyMessage] = useState(null)

    const fetchData = async () => {
        setLoading(true);

        axios.get('invitations').catch((e) => {
            setLoading(false);
            console.log(`failed to get invitations with error`, e);
            appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to get invitations' });
        }).then(result => {
            console.log('invitations result', result)
            if (result?.data?.response) {
                let responseData = result.data.response.sort((a, b) => {
                    return a.created_at > b.created_at ? -1 : 1
                })
                let filteredData = responseData.filter(d => d.accepted === 0)
                setData(filteredData);
                // console.log('look here', result.data.response.filter(r => r.deleted === 0))
            } else {
                setData(undefined);
            }
    
            setLoading(false);
        });
        
    };


    useEffect(() => {
        fetchData();
    }, []);

    const copyContent = async (text, code) => {
        try {
          await navigator.clipboard.writeText(text);
        //   setShowCopyMessage(code)

        //   appCtx.setAlert({type: 'message', message: 'Copied!'})
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
    };

    let briefs = [];
    if (data) {
        briefs = data.map((b) => [
            b.email,
            b.organization.name,
            (       
                <Button 
                    onClick={() => {
                        copyContent(`https://${b.organization.subdomain}.sympler.co/register?code=${b.code}`, b.code);
                        // setTimeout(() => {
                        //     setShowCopyMessage(null)
                        // }, 500)
                    }}
                >
                    {showCopyMessage !== b.code ? `https://${b.organization.subdomain}.sympler.co/register?code=${b.code}` : "Copied!"}
                </Button>
            ),
            // (<Button onClick={() => viewBrief(b)}>{b.name}</Button>),
            // (<Button onClick={() => viewBrief(b)}>{b.org_name}</Button>),
            b.created_at,
        ]);
    }

    const columnData = [
        {
            name: 'email',
            label: 'Email',
            options: {
                sort: true,
                filter: false,
                searchable: true,
            }
        },
        {
            name: 'orgName',
            label: 'Org Name',
            options: {
                sort: true,
                filter: true,
                searchable: true,
            }
        },
        {
            name: 'link',
            label: 'Link',
            options: {
                sort: false,
                filter: false,
            }
        },
        {
            name: 'dateInvited',
            label: 'Date Invited',
            options: {
                sort: true,
                filter: false,
                sortDirection: "desc",
            }
        }
    ]
// ["Email", "Org Name", "Link", "Date Invited"]

    return (
        <>
            {/* <Dialog open={showConfirmDelete}>
                <DialogTitle>
                    <Typography>Are you sure you want to delete this brief?</Typography>
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setShowConfirmDelete(false)}>Cancel</Button>
                    <Button onClick={() => deleteBrief(briefId)}>OK</Button>
                </DialogActions>
            </Dialog> */}
            <Grid container spacing={4} justify="center" alignItems="center">
                {loading && (
                    <Grid item>
                        <CircularProgress />
                    </Grid>
                )}
                {!loading && (
                    <Grid item xs={12}>
                        <MUIDataTable
                            title="Pending Invitations"
                            data={briefs}
                            columns={columnData}
                            // columns={[{name: "Name"}, {name: "Org Name"}, {name: "Date Submitted", options: {sort: true}},]}
                            options={{
                                download: false,
                                print: false,
                                filter: true,
                                sort: true,
                                search: true,
                                // filter: false,
                                // sort: false,
                                // search: true,
                                viewColumns: false,
                                selectableRows: 'none',
                                pagination: false,
                                                                
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};
export default Invitations;